<template>
<div class="pageContent">
  <pageTitle title='搜索' :showRight='true' rightTitle='清除' @rightHandler = 'Clean_searchParam'></pageTitle>
  <mu-paper class="search-paper" :zDepth="1">
    <mu-auto-complete hintText="按行政区、商圈、门店查询" v-model="TopMess"  :dataSource="locationData" @change="handlechange" @focus="handlechange" 
      icon="search" :maxSearchResults="10" class="inputKey" :underlineShow='false'   />
  </mu-paper>
    
  <mu-tabs :value="activeTab" @change="handleTabChange" class="kosmos-tabs">
    <mu-tab value="tabFirst" title="行政区"/>
    <mu-tab v-if='!g_searchParam.isFull' value="tabSecond" title="地铁"/>
    <mu-tab v-else value="tabThird" title="商圈"/>
    <mu-tab value="tabFourth" title="酒店"/>
  </mu-tabs>
  <div v-if="!loading">
    <div v-if="activeTab === 'tabFirst'">
        <mu-list @change="handleListChange" class="kosmos-list">
          <mu-list-item v-for="item in districtData" :value="item">
            {{item.Name}}
          </mu-list-item>
      </mu-list>
    </div>
    <div v-if="activeTab === 'tabSecond'" class="kosmos-list">
      <mu-list>
          <mu-list-item v-for="item in metroData" inset toggleNested class="metroLine" :open='false'>
            {{item.Name}}
            <mu-list-item v-for="itemStop in item.HotPointList" slot="nested" :value="itemStop" @click="selectMetro(itemStop)">
                {{itemStop.HotPointName}}
            </mu-list-item>
          </mu-list-item>
      </mu-list>
    </div>
    <div v-if="activeTab === 'tabThird'" class="kosmos-list">
      <mu-list @change="selectBusiness">
          <mu-list-item v-for="item in tradingAreaData" :value="item">
            {{item.Name}}
          </mu-list-item>
      </mu-list>
    </div>
    <div v-if="activeTab === 'tabFourth'" class="kosmos-list">
      <mu-list @change="selectHotel">
          <mu-list-item v-for="item in hotelNameData" :value="item">
            {{item.HotelName}}
          </mu-list-item>
      </mu-list>
    </div>
  </div>

  <div v-if="loading" style="text-align:center;margin-top:15vh;">
      <img src="../../../static/LoadingWhite.gif" style=" width:1.2rem ;" />
  </div>


</div>
</template>

<script>

require('es6-promise').polyfill();
require('isomorphic-fetch');
import api from '../../api'
import {mapMutations, mapGetters } from 'vuex'
export default {
  data () {
    return {
      activeTab: 'tabFirst',
      dataSource: [],
      districtData:[],
      metroData:[],
      tradingAreaData:[],
      locationData:[],
      cityId:this.$route.query,
      keyWordDic:[],
      keyWordData:[],
      hotelNameData:[],
      loading:true,

      // 跳转链接
      JumpUrl:"",

      TopMess:'',
    }
  },
  mounted(){
    this.initLocationInfo();
  },
  // created () {
  //   this.get();
  // },
  activated(){
    if( this.$router.gxxfrom.fullPath.indexOf('/search/list?BrandID') >-1 )
    {
      this.JumpUrl = "/search/list";
    }
  },

  watch:{
    $route(to, from) {
      if (to.path == "/search/key") {
       this.cityId=this.$route.query;
      }
    },
    cityId(curVal,oldVal){
      this.activeTab='tabFirst';
      this.initLocationInfo();
　　},
  },

  methods: {
    get() {
       this.initLocationInfo();
    },
    initLocationInfo(){
        var params = new this.URLSearchParam();
        params.append('cityId', this.g_city.id);
        var that=this;
        that.loading=true;


        fetch(api.getLocationListByCityId(),{
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          },
          body: "cityId="+that.g_city.id
        })
        .then(function (response) {
          if (response.status >= 400) {
            throw new Error("Bad response from server");
          }
          return response.json();
        })
        .then(function (res) {
          
          if(res.Result)
            that.dataSource=res.Data;
            that.locationData=[];
            that.districtData=[];
            that.metroData=[];
            that.tradingAreaData=[];
            that.keyWordDic=[];
            that.keyWordData=[];
            that.hotelNameData=[];

            for(var i=0;i<res.Data.Location.length;i++){
                if(res.Data.Location[i].TblType=="2"){//行政区
                    that.districtData.push(res.Data.Location[i]);
                    that.locationData.push(res.Data.Location[i].Name);
                    that.keyWordDic.push(5);
                    that.keyWordData.push(res.Data.Location[i]);

                }else if(res.Data.Location[i].TblType=="1"){//地铁
                    //that.metroData.push(res.Data.Location[i]);
                    //for(var j=0;j<res.Data.Location[i].HotPointList.length;j++){
                    //  that.locationData.push(res.Data.Location[i].HotPointList[j].HotPointName);
                    //  that.keyWordDic.push(1);
                    //  that.keyWordData.push(res.Data.Location[i].HotPointList[j]);
                    //}
                }else if(res.Data.Location[i].TblType=="0"){//商圈
                    that.tradingAreaData.push(res.Data.Location[i]);
                    that.locationData.push(res.Data.Location[i].Name);
                    that.keyWordDic.push(2);
                    that.keyWordData.push(res.Data.Location[i]);
                }
            }

            for(var i=0;i<res.Data.Hotel.length;i++){
              that.hotelNameData.push(res.Data.Hotel[i]);
              that.locationData.push(res.Data.Hotel[i].HotelName);
              that.keyWordDic.push(3);
              that.keyWordData.push(res.Data.Hotel[i]);
            }


             that.loading=false;

        });



        //this.$http.post(api.getLocationListByCityId(),params.toParam()).then((res) => {
        
            
        //})
        
        
    },

    Clean_searchParam (){
      // this.setG_searchKeyWord("");

      var searchParam = this.clearSearchParam();
      //searchParam.areaId = "";
      this.setG_searchParam(searchParam);

      this.setG_searchKeyWord('');
      
      this.TopMess = '';

      javascript: history.go(-1);
    },





    handleTabChange (val) {
      this.activeTab = val
    },
    handlechange (val) {
      console.log(val)
      var dataIndex=this.locationData.indexOf(val);
      if(dataIndex>-1){
        var pointType=this.keyWordDic[dataIndex];
        if(pointType==1){//地铁
          this.selectMetro(this.keyWordData[dataIndex])
        }else if(pointType==2){//商圈
          this.selectBusiness(this.keyWordData[dataIndex])
        }else if(pointType==5){//行政区
          this.handleListChange(this.keyWordData[dataIndex])
        }else if(pointType==3){
          this.selectHotel(this.keyWordData[dataIndex]);
        }
      }
      
    },
    handleListChange(val){
      var searchParam=this.clearSearchParam();
      searchParam.PointType=val.PointType;
      searchParam.PointText=val.Name;
      if(val.TblType=="2"){
        searchParam.areaId=val.Cityid;
      }

      this.setG_searchParam(searchParam);
      this.setG_searchKeyWord(val.Name);
      // this.$router.push({ path: '/home/index'})
      
      this.goback();
      
    },
    selectMetro(val){
      var searchParam=this.clearSearchParam();
      searchParam.areaZoneId = '';
      searchParam.lng = val.BmapPointy;
      searchParam.lat = val.BmapPointx;
      searchParam.hotPointId=val.HotPointId;
      this.setG_searchParam(searchParam);
      this.setG_searchKeyWord(val.HotPointName);
      // this.$router.push({ path: '/home/index'})

      this.goback();
    },
    selectBusiness(val){
      console.log(val)
      var searchParam=this.clearSearchParam();
      searchParam.PointType=2;
      searchParam.PointText=val.Name;
      var pointXY=val.Pointxy.split(",");
      searchParam.pointX=pointXY[0];
      searchParam.pointY=pointXY[1];
      searchParam.hotPointId=val.ID;
      this.setG_searchParam(searchParam);
      this.setG_searchKeyWord(val.Name);
      // this.$router.push({ path: '/home/index'})

      this.goback();
      
    },
    selectHotel(val){
      var searchParam=this.clearSearchParam();
      searchParam.PointType=3;
      searchParam.sort=1;
      searchParam.SortType="asc";
      searchParam.hotelCode=val.HotelCode;
      searchParam.PointText=val.HotelName;
      this.setG_searchParam(searchParam);
      this.setG_searchKeyWord(val.HotelName);
      this.goback();

    },
    clearSearchParam(){
       var searchParam=this.g_searchParam;
       //searchParam.cityId='';
       searchParam.hotelCode='';
       //searchParam.startDate='';
       //searchParam.endDate='';
       searchParam.promotionType='';
       searchParam.HotelTypeId='';
       searchParam.areaId='';
       searchParam.pointX='';
       searchParam.pointY='';
       searchParam.PointType='';
       searchParam.PointText='';
       searchParam.Sort='';
       searchParam.SortType='asc';
       searchParam.PageIndex='1';
       searchParam.PageSize='10';
       searchParam.hotPointId=''
       return searchParam;
    },

    goback() {

      console.log(this.JumpUrl)

      if( this.JumpUrl != "" ){
         this.$router.push({ path: this.JumpUrl})
      }
      else
        javascript: history.go(-1);
    },


    ...mapMutations([
      'setG_searchParam',
      'setG_searchKeyWord'
    ])
  },
  computed: {
    ...mapGetters([
      'g_city',
      'g_searchParam',
      'g_searchKeyWord'
    ])
  }
}
</script>
<style lang="less">
@import "../../assets/theme.less";
@import "../../assets/common.less";
.pageContent{
  
  .inputKey{
    .mu-text-field{
      width:100%;
      margin-bottom:4px;
      margin-top:4px;
      .mu-text-field-content{
        .mu-text-field-hint{
          text-align:left;
        }
      }
      
    }
  }

  

}
</style>



// WEBPACK FOOTER //
// selectKey.vue?5b63dc9d